<template>
	<div class="left_swiper swiper-container">
		<div class="swiper-wrapper">
			<div @click="goDetail(item.id,1)" class="swiper-slide" :key="index" v-for="(item,index) in datas">
				<img :src="item.sz_img" alt="">
				<div class="text_wrap">
					<div class="text_title line-1">{{item.title||""}}</div>
					<div class="text_content line-2">{{item.content||""}}</div>
				</div>
			</div>
		</div>
		<div class="calandor">
			<div class="year">{{year||"--"}}</div>
			<div class="day">{{month||'--'}}-{{day||'--'}}</div>
		</div>
		<div class="pagination2 swiper-pagination"></div>
	</div>
</template>

<script>
	export default{
		props:{
			swiperData:{
				type:Array,
				default:() => {
					return []
				}
			}
		},
		data(){
			let year = new Date().getFullYear();
			let month = (new Date().getMonth()+1)>9
			?(new Date().getMonth()+1)
			:`0${(new Date().getMonth()+1)}`;
			let day = new Date().getDate()>9
			?new Date().getDate()
			:`0${new Date().getDate()}`;
			return{
				year:year,
				month:month,
				day:day,
				datas:[]
			}
		},
		watch: {
			swiperData(value){
				this.datas = value;
				this.$nextTick(() => {
					this.initSwiper();
				})
			}
		},
		methods:{
			initSwiper(){
				new this.$swiper('.left_swiper',{
					pagination:{
						el:'.pagination2'
					}
				})
			},
			goDetail(id,flag){
				// console.log(id,flag);
				this.$emit("goDetail",id,flag)
			}
		}
	}
</script>

<style lang="scss" >
	.left_swiper{
		position: relative;
		width: 49.5rem;
		height: 100%;
		min-width: 45.5625rem;
		border-radius: 1rem;
		margin-right: 1.5rem;
		background:#ededed;
		.swiper-slide{
			img{
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
		.pagination2{
			position: absolute;
			bottom:0px !important;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 1.9375rem;
			background: linear-gradient(90deg, rgb(73,1,1) 0%, rgb(133,0,0) 50%, rgb(73,1,1) 100%);
			.swiper-pagination-bullet{
				background-color: #fff !important;
				opacity: .4;
				height: 0.5rem;
				width: 0.5rem;
				border-radius: 0.5rem;
				transition: all .3s;
			}
			.swiper-pagination-bullet-active{
				width: 1.5rem;
				opacity: 1 !important;
			}
		}
		.calandor{
			position: absolute;
			z-index: 10;
			left: 1.625rem;
			top: 1.625rem;
			color: #fff;
			border-radius: 1rem;
			padding: 1rem 1.25rem;
			background: rgba(0, 0, 0, 0.1);
			backdrop-filter: blur(3.375rem);
			.year{
				font-size: 2.25rem;
				font-weight: bold;
			}
			.day{
				margin-top: 0.1875rem;
				font-size: 1.5rem;
				letter-spacing: 0.25rem;
			}
		}
		.text_wrap{
			padding: 0.9375rem;
			position: absolute;
			bottom: 30px;
			left: 0;
			width: 100%;
			color: #fff;
			z-index: 10;
			background: linear-gradient(180deg, transparent 0%, #000000 100%);
			.text_title{
				font-size: 1.5rem;
				font-weight: bold;
				width: 100%;
				height: 30px;
				line-height: 30px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
			.text_content{
				font-size: 1.125rem;
				margin-top: 1rem;
				line-height: 1.875rem;
				width: 95%;
				// height: 30px;
				// line-height: 30px;
				display: -webkit-box;//对象作为弹性伸缩盒子模型显示
				overflow: hidden;//溢出隐藏
				-webkit-box-orient: vertical;//设置伸缩盒子对象的子元素的排列方式
				-webkit-line-clamp: 2;//设置 块元素包含的文本行数

			}
		}
	}
</style>